import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import { css } from "@emotion/css";
import React from "react";

import { ErrorMessages } from "../constants/ErrorMessages";

const image = css({
  height: "94vh",
  width: "100%",
  overflow: "hidden",
});

const centered = css({
  position: "absolute",
  top: "23%",
  width: "618px",
  height: "128px",
});

const errorHeader = css({
  width: "618px",
  height: "48px",
  lineHeight: "48px",
  textAlign: "center",
  color: "#232F3E",
});

const errorDescription = css({
  width: "618px",
  height: "28px",
  lineHeight: "28px",
  textAlign: "left",
  color: "#697576",
});

export const ErrorFallbackpage = () => {
  
  return (
    <Column alignmentHorizontal="center" data-testid="errorfallbackpage-container-column">
      <div className={image}>
        <img
          className={image}
          src="https://m.media-amazon.com/images/G/31/CONSTELLATION/desktop-error-screen.png"
          alt="error-icon"
        />
      </div>
      <div className={centered}>
        <Row spacingInset="none none 300 none" data-testid="errorfallbackpage-header-row">
          <Text className={errorHeader} type="d50" data-testid="errorfallbackpage-header-text">
            {ErrorMessages.ERROR_SCREEN_HEADER }
          </Text>
        </Row>
        <Row spacingInset="none none 500 none" data-testid="errorfallbackpage-description-row">
          <Text className={errorDescription} type="b500" data-testid="errorfallbackpage-description-text">
            {ErrorMessages.ERROR_SCREEN_DESCRIPTION}
          </Text>
        </Row>
      </div>
    </Column>
  );
};
